<template>
  <div class="step6Container">
    <div class="Container">
      <div class="Preview">
        <TabletPreview
          :order="order"
          :backColor="backColor"
          :frontColor="frontColor"
          @onClickCharacter="onClickCharacter"
        />
      </div>

      <div class="Forms" v-if="form.columns">
        <div class="Forms-Inner">
          <div class="InstructionContainer" v-if="thereIsNoActiveCharacter">
            <p class="InstructionMessage">
              異体字に変換が必要な<br />戒名の文字をタップしてください
            </p>
          </div>
          <div
            class="ReviseCharacterFormContainer"
            v-if="thereIsActiveCharacter"
          >
            <div class="FormHeader">
              <div class="CharacterImageContainer">
                <TabletCharacter
                  :itaiji="[{ character: state.character }]"
                  :font="state.font"
                  :size="75"
                />
              </div>
            </div>
            <div class="FormBody">
              <div class="ItaijiList" v-if="itaijiOptions.length">
                <p>該当する異体字を一つ選んでください</p>
                <div class="VariantCharacterSelection"></div>

                <div class="ItaijiContainer">
                  <div
                    class="CharacterImageContainer"
                    v-for="(item, index) in itaijiOptions"
                    :key="index"
                    :class="[
                      selectedItaijiImageUrl === item._imageUrlForSrc &&
                        'isActiveItaiji'
                    ]"
                    @click="onClickItaijiOption(index)"
                  >
                    <img :src="item._imageUrlForSrc" alt="item" />
                  </div>
                </div>
              </div>

              <div v-if="!itaijiOptions.length">
                <p>異体字の候補が存在しません</p>
              </div>

              <div v-if="state.character">
                <p>注意点があれば画像を添付してください</p>
                <el-upload
                  class="AddAttachmentButton"
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-change="_onChangeAttachments"
                  :file-list="fileList"
                  accept=".jpg, .png"
                  :before-remove="removeFile"
                  list-type="picture-card"
                >
                  <i class="el-icon-plus" />
                  <div class="el-upload__tip" slot="tip">
                    jpgまたはpngファイル、 10MB以内
                  </div>
                </el-upload>
              </div>

              <div>
                <p>備考</p>
                <el-input :value="comment" @input="onChangeComment($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <OrderFormFooter
      message="異体字を設定してください"
      :canClickGoBack="true"
      @onClickGoBack="onClickGoBack"
      :canClickGoForward="true"
      @onClickGoForward="onClickGoForward"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { mapState, mapGetters } from "vuex";
import { produce } from "immer";

import OrderFormFooter from "@/components/OrderFormFooter";
import TabletPreview from "@/components/Common/TabletPreview.vue";

import TabletCharacter from "@/components/TabletCharacter";

import UsecaseFactory from "@/usecases/usecase.factory.js";
import FileUsecase from "@/usecases/file.usecase";

const variantCharacterGroupUsecase = UsecaseFactory.create("variantCharacterGroup");

export default {
  components: {
    OrderFormFooter,
    TabletPreview,
    TabletCharacter,
  },
  data () {
    return {
      state: {
        font: null,
        itemName: null,
        itemKey: null,
        character: null,
        text: null,
        faceIndex: null,
        columnIndex: null,
        characterIndex: null,
      },
      activeCharacterIndex: null,
      activeColumnIndex: null,
      activeFace: 0,
      selectedItaijiIndex: null,
      itaiji: [],
      itaijiOptions: [],
      fileList: [],
      comment: null,
      selectedItaijiImageUrl: "",
    };
  },
  computed: {
    ...mapState({
      orderType: state => state.orderForm.orderTypeInput,
      typography: state => state.orderForm.typographyInput,
      printType: state => state.orderForm.typographyInput.printType,
    }),
    form: {
      get () {
        return this.$store.state.orderForm.detailInput;
      },
      set (value) {
        this.$store.commit("orderForm/setDetail", { ...value });
      },
    },
    ...mapGetters({
      previousStep: "orderForm/previousStep",
      nextStep: "orderForm/nextStep",
      order: "orderForm/order",
      frontColor: "orderForm/frontColor",
      backColor: "orderForm/backColor",
    }),
    activeCharacter () {
      const { columnIndex, itemKey, characterIndex } = this.state;
      return this.form.columns[columnIndex][itemKey][characterIndex];
    },
    thereIsActiveCharacter () {
      return this.state.character !== null;
    },
    thereIsNoActiveCharacter () {
      return !this.thereIsActiveCharacter;
    },
    isInsideColumnCharacter () {
      return this.state.columnIndex !== null;
    },
  },
  watch: {},
  async created () {},
  async mounted () {
    this.$store.commit("orderForm/setCurrentStep", 5);
  },
  methods: {
    onClickGoForward () {
      const { $router } = this;
      $router.push(this.nextStep);
    },
    onClickGoBack () {
      const { $router } = this;
      $router.push(this.previousStep);
    },
    _isSelected () {
      const { printType, font, frontColor, backColor } = this.form;
      return !!(printType && font && frontColor && backColor);
    },
    onClickCharacter (payload) {
      const { character } = payload;
      // 表か裏か
      // this.activeFace = 0;
      // 何霊目か
      // this.activeColumnIndex = 0;
      // 何番目の文字か
      // this.activeCharacterIndex = 0;
      // を取得する
      this.state = { ...payload };
      // 選択された文字に応じた異体字グループを検索する
      const { font } = this.order.detail.typography;
      this.state.font = font;
      const query = {
        font,
        // クエリの仕様上、複数の文字を検索できるが、
        // UIの仕様上、1文字ずつのみ検索する
        searchConditions: [character],
      };
      this.getVariantCharacterGroups(query);
      this.getPointsImages();
      this.getComment();
      this.selectedItaijiImageUrl = payload.characterDetail.imageUrl;
    },

    _onClickBuddhistNameCharacter (columnIndex, characterIndex) {
      this.activeFace = 0;
      this.activeColumnIndex = columnIndex;
      this.activeCharacterIndex = characterIndex;
      this.getVariantCharacterGroups();
    },
    _onClickSecularNameCharacter (columnIndex, characterIndex) {
      this.activeFace = 1;
      this.activeColumnIndex = columnIndex;
      this.activeCharacterIndex = characterIndex;
      this.getVariantCharacterGroups();
    },
    _onClickOk () {
      this.activeCharacterIndex = null;
    },
    onClickItaijiOption (index) {
      const { columnIndex, itemKey, characterIndex } = this.state;
      if (this.selectedItaijiIndex === index) {
        this.selectedItaijiIndex = null;
        this.selectedItaijiImageUrl = "";
        if (this.isInsideColumnCharacter) {
          if (itemKey === "underCharacters") {
            this.form = produce(this.form, d => {
              let target = d.columns[columnIndex][itemKey][characterIndex];
              // 異体字IDの反映
              // 異体字画像の反映
              if (d.columns.length > 1) {
                let target2 = d.columns[columnIndex === 0 ? 1 : 0][itemKey];
                let targetCharacterIndex = 0;
                let result = false;
                for (let item of target2) {
                  if (item.character === target.character) {
                    result = true;
                    break;
                  }
                  targetCharacterIndex++;
                }
                if (result) {
                  target2[targetCharacterIndex] = {
                    ...target,
                    variantCharacterId: null,
                    imageUrl: null,
                  };
                }
              }
              d.columns[columnIndex][itemKey][characterIndex] = {
                ...target,
                variantCharacterId: null,
                imageUrl: null,
              };
            });
          } else {
            this.form = produce(this.form, d => {
              let target = d.columns[columnIndex][itemKey][characterIndex];
              // 異体字IDの反映
              // 異体字画像の反映
              d.columns[columnIndex][itemKey][characterIndex] = {
                ...target,
                variantCharacterId: null,
                imageUrl: null,
              };
            });
          }
        } else {
          this.form = produce(this.form, d => {
            if (d[itemKey]) {
              let target = d[itemKey][characterIndex];
              // 異体字IDの反映
              // 異体字画像の反映
              d[itemKey][characterIndex] = {
                ...target,
                variantCharacterId: null,
                imageUrl: null,
              };
            }
          });
        }
        this.selectedItaijiImageUrl = "";
        return;
      }
      // TODO: stateに変更したことによる処理の変更を行う
      this.selectedItaijiIndex = index;
      // 反映を行う
      if (this.isInsideColumnCharacter) {
        // 位表記の場合、同じ文字も同期させる
        if (itemKey === "underCharacters") {
          this.form = produce(this.form, d => {
            let target = d.columns[columnIndex][itemKey][characterIndex];
            // 異体字IDの反映
            // 異体字画像の反映
            if (d.columns.length > 1) {
              let target2 = d.columns[columnIndex === 0 ? 1 : 0][itemKey];
              let targetCharacterIndex = 0;
              let result = false;
              for (let item of target2) {
                if (item.character === target.character) {
                  result = true;
                  break;
                }
                targetCharacterIndex++;
              }
              if (result) {
                target2[targetCharacterIndex] = {
                  ...target,
                  variantCharacterId: this.itaijiOptions[index].id,
                  imageUrl: this.itaijiOptions[index]._imageUrlForSrc,
                };
              }
            }
            d.columns[columnIndex][itemKey][characterIndex] = {
              ...target,
              variantCharacterId: this.itaijiOptions[index].id,
              imageUrl: this.itaijiOptions[index]._imageUrlForSrc,
            };
          });
        } else {
          this.form = produce(this.form, d => {
            let target = d.columns[columnIndex][itemKey][characterIndex];
            // 異体字IDの反映
            // 異体字画像の反映
            d.columns[columnIndex][itemKey][characterIndex] = {
              ...target,
              variantCharacterId: this.itaijiOptions[index].id,
              imageUrl: this.itaijiOptions[index]._imageUrlForSrc,
            };
          });
        }
        this.selectedItaijiImageUrl = this.itaijiOptions[index]._imageUrlForSrc;
      } else {
        this.form = produce(this.form, d => {
          if (d[itemKey]) {
            let target = d[itemKey][characterIndex];
            // 異体字IDの反映
            // 異体字画像の反映
            d[itemKey][characterIndex] = {
              ...target,
              variantCharacterId: this.itaijiOptions[index].id,
              imageUrl: this.itaijiOptions[index]._imageUrlForSrc,
            };
          }
        });
      }
      this.selectedItaijiImageUrl = this.itaijiOptions[index]._imageUrlForSrc;
    },
    async getVariantCharacterGroups (q) {
      const loading = this.$loading();
      const options = { q };
      // グループの取得
      let variantCharacterGroups;
      try {
        variantCharacterGroups = await variantCharacterGroupUsecase.getVariantCharacterGroups(
          options
        );
      } catch (err) {
        this.loading = false;
        // console.log(err);
        this.$notify.error({
          title: "エラー - 異体字グループ",
          message: err.errors[0].message,
        });
        loading.close();
        return;
      }

      // 異体字画像のURLにはファイル名のみが登録されているため、S3から取得できるURLを専用のキーへ保存する
      const promises = [];
      variantCharacterGroups.forEach(group => {
        if (group.variantCharacters) {
          group.variantCharacters.forEach(character => {
            const promise = this.setImageUrlForSrc(character);
            promises.push(promise);
          });
        }
      });
      try {
        await Promise.all(promises);
      } catch (err) {
        this.loading = false;
        console.log(err);
        this.$notify.error({
          title: "エラー",
          message: "異体字画像URLの取得に失敗しました。",
        });
        return;
      }

      this.itaijiOptions = variantCharacterGroups.reduce(
        (pre, cur) => [...pre, ...cur.variantCharacters],
        []
      );
      loading.close();

      // this.loading = false;
      // this.hasSearched = true;
    },
    /**
     * VariantCharacterに表示用のURL（VariantCharacter._imageUrlForSrc）を追加
     * ※ 副作用として、引数:variantCharacterに variantCharacter._imageUrlForSrc {string} が追加されます。
     * @param {VariantCharacter} variantCharacter
     */
    async setImageUrlForSrc (variantCharacter) {
      if (!variantCharacter.imageUrl) return;

      // 元からURLで登録されている場合、元の値を利用する
      if (variantCharacter.imageUrl.match(/^http/)) {
        variantCharacter._imageUrlForSrc = variantCharacter.imageUrlForTablet;
        return;
      }

      // ファイル名のみ登録されている場合、画像URLに変換する
      return usecase.file.fetchURL(variantCharacter.imageUrl).then(url => {
        variantCharacter._imageUrlForSrc = url;
      });
    },
    async getPointsImages () {
      // TODO: column index 無いやつに対応する
      const { columnIndex, itemKey, characterIndex } = this.state;
      this.fileList = [];
      if (columnIndex !== null) {
        const points = await Promise.all(
          this.form.columns[columnIndex][itemKey][characterIndex].points.map(
            async key => {
              const url = await usecase.file.fetchURL(key);
              return {
                name: key,
                url,
              };
            }
          )
        );
        // UIへの反映する
        this.fileList = points;
        return;
      }
      const points = await Promise.all(
        this.form[itemKey][characterIndex].points.map(async key => {
          const url = await usecase.file.fetchURL(key);
          return {
            name: key,
            url,
          };
        })
      );
      // UIへの反映する
      this.fileList = points;
    },
    async getComment () {
      const { columnIndex, itemKey, characterIndex } = this.state;
      this.comment = null;
      if (columnIndex !== null) {
        this.comment = this.form.columns[columnIndex][itemKey][characterIndex].comment;
        return;
      }
      this.comment = this.form[itemKey][characterIndex].comment;
    },
    removeFile (file) {
      const removeTargetIndex = _.findIndex(
        this.activeCharacter.points,
        o => o === file.name
      );
      if (removeTargetIndex === -1) {
        return false;
      }
      const { columnIndex, itemKey, characterIndex } = this.state;
      // UI側の配列にも反映させる
      this.fileList.splice(removeTargetIndex, 1);
      // 反映を行う
      if (this.isInsideColumnCharacter) {
        this.form = produce(this.form, d => {
          let target = d.columns[columnIndex][itemKey][characterIndex];
          d.columns[columnIndex][itemKey][characterIndex].points = target.points.filter((_, i) => i !== removeTargetIndex);
        });
        return;
      }
      this.form = produce(this.form, d => {
        let target = d[itemKey][characterIndex];
        d[itemKey][characterIndex].points = target.points.filter(
          (_, i) => i !== removeTargetIndex
        );
      });
    },
    async _onChangeAttachments (file, fileList) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // xlarge: 10MB（上限引き上げの話があり見積もり等含めて OK が出たら着手する）
      if (!usecase.file.validateFileSize(file, "xlarge")) {
        // this.removeFile(file);
        fileList.pop();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "points";

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw);

        const imageUrl = await usecase.file.fetchURL(result.key);

        const addFile = {
          name: result.key,
          status: file.status,
          uid: file.uid,
          url: imageUrl,
        };

        this.fileList.push(addFile);

        // 反映を行う
        const { columnIndex, itemKey, characterIndex } = this.state;

        if (this.isInsideColumnCharacter) {
          this.form = produce(this.form, d => {
            let target = d.columns[columnIndex][itemKey][characterIndex];

            d.columns[columnIndex][itemKey][characterIndex].points = [
              ...target.points,
              result.key,
            ];
          });

          return;
        }

        this.form = produce(this.form, d => {
          let target = d[itemKey][characterIndex];

          d[itemKey][characterIndex].points = [...target.points, result.key];
        });
      } catch (err) {
        console.log(err);

        // Pop file list
        fileList.pop();
      }
    },
    onChangeComment (comment) {
      this.comment = comment;
      const { columnIndex, itemKey, characterIndex } = this.state;
      if (columnIndex !== null) {
        this.form.columns[columnIndex][itemKey][characterIndex].comment = comment;
      } else {
        this.form[itemKey][characterIndex].comment = comment;
      }
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.step6Container {
  height: 100%;
}
.Container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: auto;
}
.Preview {
  flex: 1;
  height: 100%;
}
.Preview-ImageContainer {
  width: 400px;
  height: 100%;
  margin: auto;
}
.Preview-ImageContainer > img {
  width: 100%;
}

.Forms {
  flex: 1;
  height: 465px;
}

.Forms-Inner {
  width: 90%;
  height: 100%;
  overflow: auto;
  margin: auto;
}

.InstructionContainer {
  width: 100%;
  height: 100%;
  display: flex;
}

.InstructionMessage {
  margin: auto;
  font-size: 1.2em;
  color: $text-lighter;
}

.FormHeader {
  display: flex;
  margin: 10px 0;
}

.FormBody {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.CharacterImageContainer {
  margin: auto;
  border: 1px solid black;
  background-color: gray;
  box-sizing: border-box;
}

.CharacterImageContainer img {
  width: 100%;
}

.VariantCharacterSelection {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  grid-gap: 10px;
}
.ReviseCharacterFormContainer {
  display: flex;
  height: 100%;
}

.ReviseCharacterFormContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.ItaijiContainer {
  display: grid;
  grid-gap: 10px;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
}

// .ItaijiContainer img {
// }

.isActiveItaiji {
  border-color: $blue-extra-deep;
  border-width: 6px;
  background-color: dimgray;
}

::v-deep .el-upload--picture-card,
::v-deep .el-upload-list--picture-card .el-upload-list__item {
  border-color: $--border-color-light;
}
</style>
